/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/EmailPreview/index.js
 * Created:       Tue May 27 2025
 * Modified By:   Greg Olive
 * Last Modified: Thu Nov 06 2025
 */

import React, {Fragment, useEffect, useCallback, useState, useContext} from 'react';

import LoadingSpinner from "@proxy/_components/LoadingSpinner";


export default function EmailPreview({
  previewSettings,
  emailPreviewData,
  inDashboard = false,
  purchaserEmail = false,
  isMarketsCurrency,
}) {

  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(true);

  /**
   * asyncronously get preview based on passed in params
   * @param {*} previewSettings
   */
  const getPreview = (previewSettings) => {

    const shopUrl = (() => {

      if (typeof(window.APP_ADMIN) != 'undefined') {
        return window.APP_ADMIN.request.params.shop;
      }

      if (typeof(Shopify) != 'undefined') {
        return Shopify.shop;
      }

    })();

    const activeCurrency = (isMarketsCurrency && typeof(Shopify) != 'undefined' && typeof(Shopify.currency.active) != 'undefined') ? Shopify.currency.active : null;

    const params = {
      settings: previewSettings,
      shopUrl: shopUrl,
      giftCard: emailPreviewData,
      purchaserEmail: purchaserEmail,
      activeCurrency: activeCurrency,
    };


    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(params),
    };

    const url = (() => {

      if (typeof(APP_ADMIN) != 'undefined') {
        return '/preview/email';
      }

      if (typeof(Shopify) != 'undefined') {
        return '/a/gc/preview/email';
      }

    })();

    if (inDashboard === true) {
      setLoading(true);
    }


    // Hacking debounce function on the window
    if (window.previewTimeout) clearTimeout(window.previewTimeout);

    window.previewTimeout = setTimeout(() => {

      window.previewTimeout = null;
      fetch(url, options)
      .then((res) => {
        if (res.ok) {
          return res.text();
        } else if (res.status === 500) {
          throw new Error(
            "We couldn't parse your email content. You may have a wrong number of curly braces ({}) around your variables. Please check and try again"
          );
        } else if (res.status === 404) {
          throw new Error(
            "We couldn't find your email template. Please make sure your template still exists in Klaviyo, and try again."
          );
        }
      })
      .then(
        (res) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(res, "text/html");
          setPreview(res);
          setLoading(false);
        },
        (err) => {
          console.warn(err);
          setPreview("There was an error generating the preview"); // TODO: Pull from translations
        }
      )
      .catch((err) => {
        console.warn(err);
        setPreview("There was an error generating the preview");
      });
    }, 1000);


  };

  useEffect(() => {
    getPreview(previewSettings);
  }, [previewSettings, purchaserEmail]);


  return loading === false ? (
    <Fragment>
    {/** <div dangerouslySetInnerHTML={{__html: preview}}/>*/}
    <iframe
    scrolling="yes"
    style={{
      "width": "100%",
      "maxHeight": "100%",
      "height": "1350px",
      "border": "none",
      "outline": "none"
    }}
    title="Gift Card Email Preview"
    srcDoc={preview}
    />
    </Fragment>
  ) : (
    <>
    <LoadingSpinner/>
    </>
  );

}
